import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { computed, ref } from "vue";
import { DeltaType, ArtifactDeltaSchema, ChangedArtifact } from "@/types";
import { deltaStore } from "@/hooks";
import { PanelCard } from "@/components/common";
import ArtifactDeltaDiff from "./ArtifactDeltaDiff.vue";
import DeltaButtonGroup from "./DeltaButtonGroup.vue";


/**
 * Displays artifact delta information.
 */
const __default__ = {
  name: "ArtifactDeltas",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const selectedDelta = ref<ChangedArtifact | undefined>();

const inDeltaView = computed(() => deltaStore.inDeltaView);
const addedArtifacts = computed(() => deltaStore.addedArtifacts);
const modifiedArtifacts = computed(() => deltaStore.modifiedArtifacts);
const removedArtifacts = computed(() => deltaStore.removedArtifacts);

/**
 * Selects an artifact.
 */
function handleArtifactSelect(
  name: string,
  artifact: ArtifactDeltaSchema,
  deltaType: DeltaType
): void {
  selectedDelta.value = { name, artifact, deltaType };
}

/**
 * Selects an added artifact.
 * @param id - The artifact to select.
 */
function handleAddedSelect(id: string): void {
  handleArtifactSelect(
    addedArtifacts.value[id].name,
    addedArtifacts.value[id],
    "added"
  );
}

/**
 * Selects a modified artifact.
 * @param id - The artifact to select.
 */
function handleModifiedSelect(id: string): void {
  handleArtifactSelect(
    modifiedArtifacts.value[id].after.name,
    modifiedArtifacts.value[id],
    "modified"
  );
}

/**
 * Selects a removed artifact.
 * @param id - The artifact to select.
 */
function handleRemovedSelect(id: string): void {
  handleArtifactSelect(
    removedArtifacts.value[id].name,
    removedArtifacts.value[id],
    "removed"
  );
}

return (_ctx: any,_cache: any) => {
  return (inDeltaView.value)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        title: "Artifacts",
        collapsable: "",
        borderless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(DeltaButtonGroup, {
            "delta-type": "added",
            items: addedArtifacts.value,
            onClick: handleAddedSelect
          }, null, 8, ["items"]),
          _createVNode(DeltaButtonGroup, {
            "delta-type": "modified",
            items: modifiedArtifacts.value,
            onClick: handleModifiedSelect
          }, null, 8, ["items"]),
          _createVNode(DeltaButtonGroup, {
            "delta-type": "removed",
            items: removedArtifacts.value,
            onClick: handleRemovedSelect
          }, null, 8, ["items"]),
          (!!selectedDelta.value)
            ? (_openBlock(), _createBlock(ArtifactDeltaDiff, {
                key: 0,
                open: !!selectedDelta.value,
                delta: selectedDelta.value,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (selectedDelta.value = undefined))
              }, null, 8, ["open", "delta"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})